var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.Utilities = OCS.Interfaces.Utilities || {};
OCS.Interfaces.Utilities.array = {
    array_add: function (array_a, array_b) {
        var array_c = Array.clone(array_a);
        for (var i = 0; i < array_c.length; i++) {
            array_c[i] = array_c[i] + array_b[i];
        }
        return array_c;
    },
    array_subtract: function (array_a, array_b) {
        //var array_c = Array.clone(array_a);
        var array_c = [];
        var result;
        for (var i = 0; i < array_a.length; i++) {
            result = array_a[i];
            if (!isNaN(result) && !isNaN(array_b[i])) {
                result = result - array_b[i];
            }
            if (this.is_string(result) && this.is_string(array_b[i]) && result === array_b[i]) {
                // Since the strings are equal, remove the original value
                result = null;
            }
            if (result || result === 0) {
                array_c.push(result);
            }
        }
        return array_c;
    },
    array_multiply: function (array_a, array_b) {
        var array_c = [];
        var result;
        for (var i = 0; i < array_a.length; i++) {
            result = array_a[i];
            if (!isNaN(array_b[i])) {
                result = result * array_b[i];
            }
            array_c.push(result);
        }
        return array_c;
    },

    /**
     * @method array_null_check - Returns true if any value in the array is null.
     * @param {Array} inArray
     * @returns {Boolean}
     */
    array_null_check: function (inArray) {
        var array_loop = 0;
        while (array_loop < inArray.length) {
            if (Boolean(inArray[array_loop++] === null)) {
                return true;
            }
        }
        return false;
    },

    /**
     * @method array_equal_check - Returns true if all array values are equal
     * @param {Array} inArray
     * @returns {Boolean}
     */
    array_equal_check: function (inArray) {
        var prev_value = inArray[0];
        var array_loop = 1;
        while (array_loop < inArray.length) {
            if (Boolean(inArray[array_loop] !== prev_value)) {
                return false;
            }
            prev_value = inArray[array_loop++];
        }
        return true;
    },
    /**
     * @method is_array_equal - Test if 2 arrays are equal
     * @param {type} array_a
     * @param {type} array_b
     * @returns {Boolean}
     */
    is_array_equal: function (array_a, array_b) {
        if (array_a.length !== array_b.length)
            return false;
        for (var i = array_a.length; i--; ) {
            if (typeof array_a[i] === typeof array_b[i]) {
                if (this.is_string(array_a[i]) || this.isNumber(array_a[i]) || this.is_boolean(array_a[i])) {
                    if (array_a[i] !== array_b[i]) {
                        return false;
                    }
                } else if (this.is_array(array_a[i])) {
                    if (!this.is_array_equal(array_a[i], array_b[i])) {
                        return false;
                    }
                } else if (this.is_object(array_a[i])) {
                    if (!this.object_has_object_with_prop(array_a[i], array_b[i])) {
                        return false;
                    }
                } else if (array_a[i] !== array_b[i]) {
                    return false;
                }
            } else {
                return false;
            }

        }

        return true;
    },
    array_max_object_prop: function (array, property) {
        var i;
        var max = 0;
        for (i = 1; i < array.length; i++) {
            if (parseFloat(array[max][property]) < parseFloat(array[i][property])) {
                max = i;
            }
        }
        return array[max];
    },
    /*
     * 
     * @param {Array} array The array to search for the object containig the set of values of interest
     * @param {Object} conditions An object containing the properties and values to test each array value for
     * @returns {Object|Boolean} Will return the object found if all the conditions are passed, if not will return false;
     */
    array_has_object_with_prop: function (array, conditions) {
        var pass = true;
        var test = {};
        var i, j, key, value;
        var condition_keys = this.object_keys(conditions);
        if (condition_keys.length && array.length) {
            // Loop through every element of the array to determine if the conditions match
            for (i = 0; i < array.length; i++) {
                pass = true;
                test = array[i];
                if (this.object_keys(test).length) {
                    // test all the conditions, if they all pass, return the object we found
                    for (j = 0; j < condition_keys.length; j++) {
                        key = condition_keys[j];
                        if (key in test) {
                            value = conditions[key];
                            // Key is in test
                            if (typeof value === typeof test[key]) {
                                if (this.is_string(value) || this.isNumber(value) || this.is_boolean(value)) {
                                    if (test[key] !== value) {
                                        pass = false;
                                    }
                                } else if (this.is_array(value)) {
                                    if (!this.is_array_equal(test[key], value)) {
                                        pass = false;
                                    }
                                } else if (this.is_object(value)) {
                                    if (!this.object_has_object_with_prop(test[key], value)) {
                                        pass = false;
                                    }
                                } else if (value !== test[key]) {
                                    pass = false;
                                }
                            } else {
                                pass = false;
                            }
                        } else {
                            pass = false;
                        }
                    }
                    if (pass) {
                        return test;
                    }
                }
            }
        }
        return false;
    },
    array_has_object_with_cond: function (array, conditional_callback) {
        var i;
        if (array.length) {
            // Loop through every element of the array to determine if the condition passes
            for (i = 0; i < array.length; i++) {
                if (conditional_callback(array[i])) {
                    return array[i];
                }
            }
        }
        return false;
    },
    array_combine_objects: function (arraya, arrayb) {
        var array = this.clone_object(arraya);
        var i;
        for (i = 0; i < arrayb.length; i++) {
            if (!this.array_has_object_with_prop(arraya, arrayb[i])) {
                array.combine([arrayb[i]]);
            }
        }
        return array;
    },

    array_split_by_object_prop: function (array, conditions) {
        var result = {};
        var i, j, property;
        var test = {};
        if (this.object_keys(conditions).length && array.length) {
            for (i = 0; i < array.length; i++) {
                test = array[i];
                if (this.object_keys(test).length) {
                    // split on each condition
                    for (j = 0; j < conditions.length; j++) {
                        property = conditions[j];
                        if (!result[property]) {
                            result[property] = [];
                        }
                        if ((property in test)) {
                            result[property].push(test[property]);
                        } else {
                            result[property].push(null);
                        }
                    }
                }
            }
        }
        return result;
    },

    // Used when sorting an array of objects that contain a certain property to sort by
    array_sort_with_prop: function (array, property) {
        return this.array_sort_with_cond(array, function (val) {
            return parseInt(val[property]);
        });
    },
    array_sort_with_cond: function (array, callback) {
        return this._array_sort(array, function (val) {
            return callback(val);
        });
    },
    _array_sort: function (array, get_value_callback) {
        return array.sort(function (a, b) {
            if (get_value_callback(a) > get_value_callback(b)) {
                return 1;
            }
            if (get_value_callback(a) < get_value_callback(b)) {
                return -1;
            }
            return 0;
        });
    },

    get_vector_dir: function (array) {
        var result = [this.get_comp_direction(array[0]), this.get_comp_direction(array[1])];

    },
    get_comp_direction: function (val) {
        if (val === 0) {
            return 0;
        }
        if (val > 0) {
            return 1;
        }
        if (val < 0) {
            return -1;
        }
    },
    /**
     * Finds Min and Max from 2 dimensional array
     *
     * @method get_2dmin_array_minmax
     * @param data {Array} data from which to find data
     */
    get_2dmin_array_minmax: function (data) {
        var min_data = 9999;
        var max_data = -9999;
        for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].length; j++) {
                if (data[i][j] !== null && data[i][j] < min_data) {
                    min_data = data[i][j];
                }

                if (data[i][j] !== null && data[i][j] > max_data) {
                    max_data = data[i][j];
                }
            }
        }
        return {'max': max_data, 'min': min_data};
    }
};